"use strict";
import { Fragment, jsx } from "react/jsx-runtime";
import { usePermissionCheck } from "../hooks";
const DefaultError = () => null;
export const PermissionBoundary = (props) => {
  const { required, forbidden = [], error: Error = DefaultError, children } = props;
  const hasRequiredPermissions = usePermissionCheck(required);
  const hasForbiddenPermissions = usePermissionCheck(forbidden);
  if (!hasRequiredPermissions || forbidden.length > 0 && hasForbiddenPermissions) return /* @__PURE__ */ jsx(Error, {});
  return /* @__PURE__ */ jsx(Fragment, { children });
};
